import HeroSection from './components/HeroSection';
import IdentitySection from './components/IdentitySection';
import SolutionsSection from './components/SolutionsSection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <IdentitySection />
      <SolutionsSection />
      <ContactFooter />
    </main>
  );
}